"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _react = _interopRequireWildcard(require("react"));

var _index = _interopRequireDefault(require("../style/index"));

var _input = _interopRequireDefault(require("../views/input"));

var _DropDownSearch = _interopRequireDefault(require("../../DropDownSearch"));

var _Divider = _interopRequireDefault(require("../../Divider"));

var _createStyled = require("../../../utils/createStyled");

var _icons = _interopRequireDefault(require("../icons"));

function template() {
  var styles = this.compileStyled(_index["default"]),
      _this$state = this.state,
      collection = _this$state.collection,
      number = _this$state.number,
      code = _this$state.code,
      _this$props = this.props,
      label = _this$props.label,
      lang = _this$props.lang,
      className = _this$props.className,
      disabled = _this$props.disabled,
      readOnly = _this$props.readOnly,
      attribute = _this$props.attribute,
      onKeyDown = _this$props.onKeyDown,
      maxLength = _this$props.maxLength,
      theme = _this$props.theme,
      style = _this$props.style;
  var labelContent = null,
      list = null;

  if (label) {
    labelContent = _react["default"].createElement(_createStyled.Styled.Div, {
      styles: styles.label
    }, label);
  }

  if (collection && collection.length) {
    var name;
    list = collection.map(function (item) {
      var computedLang = lang === 'uk' ? 'ua' : lang,
          FlagIcon = _icons["default"][item.image];
      name = item.name && item.name[computedLang] || item.name.ua;
      return _react["default"].createElement(_createStyled.Styled.Div, {
        key: item.id,
        value: item.id,
        name: name,
        title: name,
        styles: styles.item
      }, _react["default"].createElement(_createStyled.Styled.Div, {
        styles: styles.itemImg
      }, _react["default"].createElement(_react.Suspense, {
        fallback: null
      }, _react["default"].createElement(FlagIcon, {
        width: 16
      }))), _react["default"].createElement(_createStyled.Styled.Div, {
        styles: styles.itemCode
      }, item.dialCode), _react["default"].createElement(_createStyled.Styled.Div, {
        styles: styles.itemName
      }, name));
    });
  }

  return _react["default"].createElement(_createStyled.Styled.Div, {
    className: className,
    styles: styles.root,
    ref: this.root
  }, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.wrapper,
    onMouseEnter: this._handleHover,
    onMouseLeave: this._handleRootBlur
  }, labelContent, _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.input
  }, _react["default"].createElement(_DropDownSearch["default"], {
    value: code,
    onChange: this._handleChangeCode,
    disabled: disabled,
    readOnly: readOnly,
    placeholder: "+380",
    searchFunc: this._codeSearchFunc,
    attribute: attribute + '-code',
    style: styles.code,
    virtualized: true,
    maxLength: maxLength
  }, list), _react["default"].createElement(_createStyled.Styled.Div, {
    styles: styles.divider
  }, _react["default"].createElement(_Divider["default"], {
    vertical: true
  })), _react["default"].createElement(_input["default"], {
    elementRef: this._inputRef,
    onFocus: this._handleFocus,
    onBlur: this._handleBlur,
    onKeyDown: onKeyDown,
    value: this._numberFormat(number, code),
    onChange: this._handleChangeNumber,
    onPaste: this._handlePaste,
    disabled: disabled,
    readOnly: readOnly,
    placeholder: "000000000",
    type: "tel",
    attribute: attribute + '-number',
    style: style === null || style === void 0 ? void 0 : style.input,
    theme: theme
  })), _react["default"].createElement(_createStyled.Styled.Hr, {
    styles: styles.border
  }), _react["default"].createElement(_createStyled.Styled.Hr, {
    styles: styles.activeBorder
  })));
}